import React from "react";
import Section from "@/components/ui/section";

export default function MasonryGrid({ data = [] }) {
    if (!data?.length) return null;

    const rows = [];
    const logs = [];

    const len = data.length;
    let i = 0;

    // Loop through all images
    while (i < len) {
        const current = data[i];
        const currentAlt = current?.attributes?.alternativeText || "";
        const currentType = currentAlt.startsWith("L") ? "L" : "P";
        const next = data[i + 1];
        const nextAlt = next?.attributes?.alternativeText || "";
        const nextType = nextAlt.startsWith("L") ? "L" : "P";

        // Handle Landscape: full row
        if (currentType === "L") {
            rows.push([current]);
            logs.push(`Item ${i + 1}: ${currentAlt} - Landscape (L) → full row (Row ${rows.length})`);
            i++; // Move to next item
        }
        // Handle Portrait
        else if (currentType === "P") {
            // Last row special case: P + L or L + P in the last row
            if (i === len - 2 && next) {
                const nextAlt = next?.attributes?.alternativeText || "";
                const nextType = nextAlt.startsWith("L") ? "L" : "P";

                // Check if it's P + L or L + P for the last row
                if (
                    (currentType === "P" && nextType === "L") ||
                    (currentType === "L" && nextType === "P")
                ) {
                    rows.push([current, next]); // Add both P + L or L + P in the same row
                    logs.push(`Item ${i + 1}: ${currentAlt} - Portrait (P)`);
                    logs.push(`Item ${i + 2}: ${nextAlt} - Landscape (L) → P + L or L + P in same row (Row ${rows.length})`);
                    i += 2; // Skip both items since they've been added
                    continue;
                }
            }

            // Consecutive P + P
            if (next && nextType === "P") {
                rows.push([current, next]);
                logs.push(`Item ${i + 1}: ${currentAlt} - Portrait (P)`);
                logs.push(`Item ${i + 2}: ${nextAlt} - Portrait (P) → consecutive → Row ${rows.length}`);
                i += 2; // Skip next item
            }
            // Single P (half row + empty)
            else {
                rows.push([current]);
                logs.push(`Item ${i + 1}: ${currentAlt} - Portrait (P) → half row + empty (Row ${rows.length})`);
                i++; // Move to next item
            }
        }
    }

   /* console.log("=== MASONRY LOG ===");
    logs.forEach((l) => console.log(l));
    console.log("===================");*/

    return (
        <Section>
            <div className="w-screen max-w-none -mx-4 sm:-mx-6 md:-mx-8 lg:-mx-12">
                <div className="flex flex-col gap-2 sm:gap-4">
                    {rows.map((row, rowIndex) => {
                        const isSingleImage = row.length === 1;
                        const isSinglePortrait =
                            isSingleImage && row[0]?.attributes?.alternativeText?.startsWith("P");
                        const isMixedRow =
                            row.length === 2 &&
                            row.some((img) => img.attributes.alternativeText?.startsWith("P")) &&
                            row.some((img) => img.attributes.alternativeText?.startsWith("L"));
                        const gridCols = isSinglePortrait
                            ? "grid-cols-2"
                            : isSingleImage
                                ? "grid-cols-1"
                                : "grid-cols-2";

                        return (
                            <div key={rowIndex} className={`grid ${gridCols} gap-2 sm:gap-4`}>
                                {row.map((item, index) => {
                                    const alt = item?.attributes?.alternativeText || "";
                                    const isLandscape = alt.startsWith("L");

                                    return (
                                        <div
                                            key={index}
                                            className={`overflow-hidden flex items-center ${
                                                isMixedRow && isLandscape ? "justify-center" : ""
                                            }`}
                                        >
                                            <img
                                                className={`w-full object-cover ${
                                                    isMixedRow && isLandscape ? "max-w-[80%]" : ""
                                                }`}
                                                src={item?.attributes?.url}
                                                alt={alt || `gallery-photo-${rowIndex}-${index}`}
                                                loading="lazy"
                                            />
                                        </div>
                                    );
                                })}

                                {isSinglePortrait && (
                                    <div className="w-full h-auto bg-transparent" />
                                )}
                            </div>
                        );
                    })}
                </div>
            </div>
        </Section>
    );
}